import type { ThemeMode, ThemeStateLocal } from "../themeState";
import { DEFAULT_DENSITY, DEFAULT_EFFECTS, DEFAULT_SHAPE, DEFAULT_TYPOGRAPHY } from "../meta";

interface Props {
  state: ThemeStateLocal;
  mode: ThemeMode;
}

export function LivePreview({ state, mode }: Props) {
  const t = state[mode];
  if (!t) {
    return (
      <div className="nx-card p-8 text-center text-fg-subtle text-xs">
        Tokens no cargados.
      </div>
    );
  }

  const isLight = mode === "light";
  const fx = state.effects || DEFAULT_EFFECTS;
  const typo = state.typography || DEFAULT_TYPOGRAPHY;
  const shp = state.shape || DEFAULT_SHAPE;
  const den = state.density || DEFAULT_DENSITY;

  const a1 = fx.auroraStrength;
  const a2 = fx.auroraStrength2;
  const gl = fx.glowStrength;

  const heroAuroras =
    `radial-gradient(ellipse at 12% 0%, color-mix(in srgb, ${t.accent} ${a1}%, transparent), transparent 55%), ` +
    `radial-gradient(ellipse at 90% 100%, color-mix(in srgb, ${t.accent2} ${a2}%, transparent), transparent 60%)`;

  const heroBaseGradient = isLight
    ? `linear-gradient(180deg, ${t.surface} 0%, ${t.bg} 100%)`
    : `linear-gradient(180deg, color-mix(in srgb, ${t.surface} 92%, transparent) 0%, color-mix(in srgb, ${t.bg} 95%, transparent) 100%)`;

  const ctaShadow = `0 4px 18px color-mix(in srgb, ${t.accent} ${gl}%, transparent)`;

  const r = shp.radius;
  const rLg = (r * 3.5).toFixed(1);

  const pad = den.pad;
  const gap = den.gap;

  return (
    <div className="rounded-xl overflow-hidden border border-border shadow-xl">
      {/* Hero */}
      <div
        style={{
          background: `${heroAuroras}, ${heroBaseGradient}, ${t.bg}`,
          borderBottom: `1px solid ${t.accent}`,
          padding: `${pad}px ${pad * 0.85}px`,
        }}
      >
        <div
          style={{
            fontFamily: typo.mono,
            fontSize: 10,
            letterSpacing: "0.14em",
            color: t.accent,
            textTransform: "uppercase",
            marginBottom: gap * 0.6,
          }}
        >
          DESCUBRÍ · 19
        </div>
        <div
          style={{
            fontFamily: typo.serif,
            fontSize: 32,
            lineHeight: 0.95,
            color: t.textStrong,
            marginBottom: gap * 0.9,
            letterSpacing: "-0.02em",
          }}
        >
          BigDogz —
          <br />
          Claudio Bastardo
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: `${gap * 0.7}px ${gap * 1.2}px`,
            marginBottom: gap * 0.9,
          }}
        >
          <div>
            <div
              style={{
                fontFamily: typo.mono,
                fontSize: 9,
                letterSpacing: "0.14em",
                color: t.accent,
                textTransform: "uppercase",
                marginBottom: 4,
              }}
            >
              FECHA
            </div>
            <div style={{ fontFamily: typo.sans, fontSize: 13, color: t.text }}>
              sáb, 20 de junio
            </div>
          </div>
          <div>
            <div
              style={{
                fontFamily: typo.mono,
                fontSize: 9,
                letterSpacing: "0.14em",
                color: t.accent,
                textTransform: "uppercase",
                marginBottom: 4,
              }}
            >
              VENUE
            </div>
            <div style={{ fontFamily: typo.sans, fontSize: 13, color: t.text }}>
              479, 19
            </div>
          </div>
        </div>
        <button
          style={{
            background: t.accent,
            color: t.accentInk,
            border: "none",
            padding: "12px 28px",
            borderRadius: 999,
            fontFamily: typo.sans,
            fontSize: 13,
            fontWeight: 600,
            cursor: "default",
            boxShadow: ctaShadow,
          }}
        >
          Ver evento
        </button>
      </div>

      {/* Sub */}
      <div style={{ background: t.bg, padding: `${gap}px ${pad * 0.85}px` }}>
        <div
          style={{
            display: "flex",
            gap: 8,
            marginBottom: gap * 0.8,
            flexWrap: "wrap",
          }}
        >
          <span
            style={{
              padding: "6px 14px",
              border: `1px solid ${t.accent}`,
              color: t.accent,
              borderRadius: 999,
              fontFamily: typo.sans,
              fontSize: 11,
            }}
          >
            TODOS
          </span>
          <span
            style={{
              padding: "6px 14px",
              background: t.surface,
              border: `1px solid ${t.border}`,
              color: t.textDim,
              borderRadius: 999,
              fontFamily: typo.sans,
              fontSize: 11,
            }}
          >
            TRENDING
          </span>
          <span
            style={{
              padding: "6px 14px",
              background: t.surface,
              border: `1px solid ${t.border}`,
              color: t.textDim,
              borderRadius: 999,
              fontFamily: typo.sans,
              fontSize: 11,
            }}
          >
            TECHNO
          </span>
        </div>
        <div
          style={{
            background: t.surface,
            border: `1px solid ${t.border}`,
            borderRadius: `${rLg}px`,
            padding: gap * 0.7,
          }}
        >
          <div
            style={{
              fontSize: 10,
              color: t.accent,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              marginBottom: 6,
              fontFamily: typo.mono,
            }}
          >
            EN TENDENCIA
          </div>
          <div
            style={{
              fontFamily: typo.serif,
              fontSize: 18,
              color: t.textStrong,
            }}
          >
            Trending Now
          </div>
          <div
            style={{
              fontFamily: typo.sans,
              fontSize: 12,
              color: t.textDim,
              marginTop: 4,
            }}
          >
            Los eventos con más venta esta semana.
          </div>
        </div>
      </div>
    </div>
  );
}
